import type { CSSProperties, ReactNode, RefObject } from "react";
import { LinearProgress } from "@mui/material";
import cx from "classnames";
import { LoadingIndicator } from "src/components/general/LoadingIndicator/LoadingIndicator";

interface CardContentProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  isLoading?: boolean;
  loaderType?: "linear" | "circular";
  ref?: RefObject<HTMLDivElement> | ((ref: HTMLDivElement) => void);
}

const CardContent = ({
  children,
  className,
  style,
  isLoading,
  loaderType = "linear",
  ref,
}: CardContentProps) => (
  <div ref={ref} className={cx("not-first:mt-5 flex-1", className)} style={style}>
    {isLoading ? (
      loaderType === "linear" ? (
        <LinearProgress sx={{ margin: "auto", width: "100%" }} />
      ) : (
        <LoadingIndicator loading />
      )
    ) : (
      children
    )}
  </div>
);

export default CardContent;
